import * as yup from 'yup'

export const signUpSchema = yup.object({
  inviteCode: yup.string().default(''),
  name: yup.string().default(''),
  email: yup
    .string()
    .email('Please enter a valid email address')
    .test('has-tld', 'Email must contain a valid domain', value =>
      /\.[a-z]{2,}$/i.test(value || ''),
    )
    .required('Email is required'),
  password: yup
    .string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  isAdult: yup
    .boolean()
    .oneOf([true], 'You need to verify you are 18 or older')
    .required(),
  agreedToTerms: yup
    .boolean()
    .oneOf([true], 'You have to agree to the Terms of use and Privacy policy')
    .required(),
  handle: yup.string().required('Username is required'),
  selectedInterests: yup.array().of(yup.string().required()).default([]),
})

export type SignUpFormData = yup.InferType<typeof signUpSchema>
